import React, { useState } from "react";
import * as Mui from "@mui/material";
import { themes } from "services/constants";

// The "Report Names" list that Payroll Reports and Statutory Reports open
// on: one clickable row per report (label), paged when there are more
// than 10.
export const ReportNamesList = ({ reports, onOpen }) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  return (
    <>
      <Mui.Grid sx={{ ml: 2, mr: 4 }}>
        <Mui.TableContainer sx={{ mt: 8, width: "100%", maxHeight: 850 }}>
          <Mui.Table className="border">
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <Mui.TableRow>
                <Mui.TableCell sx={{ color: themes.headLine, fontWeight: "bold" }}>Report Names</Mui.TableCell>
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {reports.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((report) => (
                <Mui.TableRow key={report.label} onClick={() => onOpen(report)} sx={{ cursor: "pointer" }}>
                  <Mui.TableCell sx={{ color: themes.headLine }}>
                    <Mui.Typography>{report.label}</Mui.Typography>
                  </Mui.TableCell>
                </Mui.TableRow>
              ))}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Mui.Grid>
      {reports.length > 10 && (
        <Mui.TablePagination
          className="custom-pagination"
          component="div"
          rowsPerPageOptions={[10, 20, 50, 100]}
          count={reports.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, next) => setPage(next)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      )}
    </>
  );
};

// Payroll reports need one company picked first (same rule for every list).
export const isAllCompanies = (companyId, companyName, allValue) =>
  companyId === allValue || companyId === "all" || (companyName && companyName.toLowerCase() === "all");
